import axiosInstance from "../axios";

/**
 * POST /api/{tenant}/bootstrap
 * - Envia If-None-Match quando houver ETag
 * - Aceita 304 como “ok, nada mudou”
 * Retorna: { notModified, etag, data }
 */
export async function fetchBootstrap({ etag } = {}) {
    const res = await axiosInstance.post(
        "/bootstrap",
        {}, // body vazio → backend usa roles do token
        {
            headers: {
                ...(etag ? { "If-None-Match": etag } : {}),
            },
            // Aceitar 304 além de 2xx
            validateStatus: (s) => (s >= 200 && s < 300) || s === 304,
        }
    );

    if (res.status === 304) {
        return {
            notModified: true,
            etag: res.headers?.etag ?? etag,
            data: null,
        };
    }

    return {
        notModified: false,
        etag: res.headers?.etag ?? null,
        data: res.data, // { version, etag, updatedAt, menu, protocolos, ... }
    };
}
